<template>
  <v-card color="grey lighten-3" class="primary--text pt-4 pe-3">
    <v-card-text>
      <v-layout align-center justify-center column >
        <v-avatar
          color="grey"
          size="60">
            <img v-if="frentista_model.url_imagem_perfil" :src="frentista_model.url_imagem_perfil" alt="trevor">
            <v-icon dark v-else>face</v-icon>
        </v-avatar>
      </v-layout>
      <v-layout column pl-3 pr-3 pt-0 pb-0>
        <v-flex>
            <v-text-field
            background-color="transparent"
            v-model="frentista_model.matricula"
            label="Matrícula:"
            required
            solo
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex
          xs5
        >
          <v-text-field
            label="Nome"
            v-model="frentista_model.nome"
            hint="Insira o primeiro nome"
            required
          ></v-text-field>
        </v-flex>
        <v-flex
          xs7
        >
          <v-text-field
            label="Sobrenome"
            v-model="frentista_model.sobrenome"
            hint="Insira o sobrenome"
          ></v-text-field>
        </v-flex>
        <v-flex
          xs6
        >
          <v-text-field
            v-model="frentista_model.cpf"
            :rules="repCpfRules"
            label="CPF"
            mask="###.###.###-##"
            required
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            :type="show ? 'text' : 'password'"
            v-model="frentista_model.pin"
            :append-icon="show ? 'visibility' : 'visibility_off'"
            placeholder="****"
            outline
            counter="4"
            single-line
            hide-details
            color="primary"
            class="centered-input display-1 font-weight-black"
            browser-autocomplete="off"
            required
            @click:append="show = !show"
            :rules="[
                    v => {
                        if (v) {
                        return v.length && v.length == 4 || ''
                        } else {
                        return false
                        }
                    }
                    ]"
            mask="NNNN"
            ></v-text-field>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions class="pa-2">
      <v-spacer></v-spacer>
      <v-btn flat @click.prevent="salvarFrentista">
        Confirmar cadastro
        <v-icon right>check</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</template>

<script>

export default {
  props: ['posto'],
  data () {
    return {
      show: false,
      valid: true,
      dialogErro: false,
      frentista_model: {
        nome: '',
        sobrenome: '',
        cnpj: null,
        pin: null,
        cpf: ''
      },
      repCpfRules: [v => !!v || 'CPF obrigatório!']
    }
  },
  methods: {
    salvarFrentista () {
      this.$store.dispatch('inserirFrentista', this.frentista_model).then((json) => {
        this.$emit('complete')
        if (!this.frentista_model.id_pessoa) {
          this.frentista_model = json
        }
      }).catch((e) => {
        alert(e)
      })
    }
  }
}
</script>
